module.exports = __webpack_public_path__ + "static/img/homeNavigation4.a423164d.png";